var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"pt-4 font-bold text-cyan underline text-left"},_vm._l((this.data),function(ref){
var url = ref.url;
var urlText = ref.urlText;
var id = ref.id;
return _c('li',{key:id,staticClass:"py-2"},[_c('a',{attrs:{"href":url,"target":"_blank","rel":"noopener"}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":['fas', ("" + _vm.iconName)]}}),_c('span',{staticClass:"pl-4"},[_vm._v(_vm._s(urlText))])],1)])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }